import onNotifyOrganizerToggled from '../actions/onNotifyOrganizerToggled';
import getNotesEditorViewState from '../selectors/getNotesEditorViewState';
import { mutator } from 'satcheljs';

export default mutator(onNotifyOrganizerToggled, ({ id, sendResponse }) => {
    const store = getNotesEditorViewState(id);
    store.sendResponse = sendResponse;
});
